import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { FOUNDER, faqSchema, pageHead, SITE_URL } from "@/lib/seo";

const c = landingPages["a-propos"]!.fr;

export const Route = createFileRoute("/a-propos")({
  head: () =>
    pageHead({
      path: "/a-propos",
      title: c.title,
      description: c.description,
      crumbs: [["À propos", "/a-propos"]],
      schemas: [
        {
          "@context": "https://schema.org",
          ...FOUNDER,
          knowsLanguage: ["fr", "en"],
          address: { "@type": "PostalAddress", addressLocality: "Bordeaux", addressCountry: "FR" },
          worksFor: { "@type": "Organization", name: "CMO Partner", url: SITE_URL },
        },
        ...(c.faq?.length ? [faqSchema(c.faq)] : []),
      ],
    }),
  component: () => <LandingPage pageKey="a-propos" />,
});
